const GA_MEASUREMENT_ID = "G-EMT09ZQB29";

declare global {
  interface Window {
    gtag: (...args: unknown[]) => void;
    dataLayer: unknown[];
    fbq: (...args: unknown[]) => void;
  }
}

export const trackEvent = (eventName: string, params?: Record<string, string | number | boolean>) => {
  if (typeof window.gtag === "function") {
    window.gtag("event", eventName, params);
  }
};

const fbTrack = (eventName: string, params?: Record<string, string | number | boolean>) => {
  if (typeof window.fbq === "function") {
    window.fbq("trackCustom", eventName, params);
  }
};

// Conversion events
export const trackApplyNowClick = (source: string) => {
  trackEvent("click", { event_category: "CTA", event_label: `Apply Now - ${source}` });
  trackEvent("apply_now_click", { source });
  if (typeof window.fbq === "function") {
    window.fbq("track", "InitiateCheckout", { content_name: `Apply Now - ${source}` });
  }
};

export const trackFormSubmission = (formType: string) => {
  trackEvent("generate_lead", { event_category: "Form", event_label: formType, value: 299 });
  trackEvent("form_submission", { form_type: formType });
  if (typeof window.fbq === "function") {
    window.fbq("track", "Lead", { content_name: formType, value: 299, currency: "USD" });
  }
};

export const trackCalculatorUsage = (monthlyVolume: number, savings: number) => {
  trackEvent("calculator_usage", { monthly_volume: monthlyVolume, potential_savings: savings });
  fbTrack("CalculatorUsage", { monthly_volume: monthlyVolume, potential_savings: savings });
};

export const trackPhoneClick = (source: string) => {
  trackEvent("phone_call", { event_category: "Contact", event_label: `${source} Phone` });
  trackEvent("phone_click", { source });
  if (typeof window.fbq === "function") {
    window.fbq("track", "Contact", { content_name: "Phone Call" });
  }
};

export const trackViewContent = (contentName: string, contentCategory: string) => {
  trackEvent("view_content", { content_name: contentName, content_category: contentCategory });
  if (typeof window.fbq === "function") {
    window.fbq("track", "ViewContent", { content_name: contentName, content_category: contentCategory });
  }
};

export const trackChatOpen = () => {
  trackEvent("chat_open");
  fbTrack("ChatOpen");
};

export const trackCTAClick = (ctaName: string, source: string) => {
  trackEvent("click", { event_category: "CTA", event_label: `${ctaName} - ${source}` });
  trackEvent("cta_click", { cta_name: ctaName, source });
  fbTrack("CTAClick", { cta_name: ctaName, source });
};

export { GA_MEASUREMENT_ID };
